<template>
  <div>
    <h4>Your Details</h4>
    <table class="cs-user-details">
      <tbody>
      <tr v-for="(row, index) in this.tableData" v-bind:key="index">
        <th scope="row">{{row.label}}:</th>
        <td v-html="row.value"></td>
      </tr>
      </tbody>
    </table>
    <div class="cs-intro-content" v-html="content"></div>
  </div>
</template>
<script>
export default {
  props: [ 'user', 'progress', 'content' ],
  computed: {
    tableData() {
      return [ {
        label: 'Name',
        value: this.fullName,
      },
        {
          label: 'Job Number',
          value: this.user.job_number,
        },
        {
          label: 'Project Address',
          value: this.user.project_address,
        },

      ];
    },
    fullName() {
      return this.user.first_name + ' ' + this.user.last_name;
    }
  }
};
</script>

<style lang="scss">
@import 'src/scss/user-page.scss';
</style>
